export default {
  en: {
    'bundles-registrations.registrations-list-page.title': 'Registrations',
  },
};
